import { render, staticRenderFns } from "./seasonHistory.vue?vue&type=template&id=4fa2e068&scoped=true"
import script from "./seasonHistory.vue?vue&type=script&lang=js"
export * from "./seasonHistory.vue?vue&type=script&lang=js"
import style0 from "./seasonHistory.vue?vue&type=style&index=0&id=4fa2e068&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2e068",
  null
  
)

export default component.exports